module.exports = __webpack_public_path__ + "img/search_white.fc0fb7dc.png";